import { makeStyles } from '@mui/styles'
import React, { useMemo } from 'react'

import Notifications from '@/modules/base/components/notification/overlay/notifications'
import ThemeInterface from '@/theme-interface'
import DrawerWithOffset from '@/components/drawers/drawer-with-offset'

const useStyles = makeStyles((theme: ThemeInterface) => ({
  drawerContainer: {
    borderRight: 'none',
  },
  wrapper: {
    maxWidth: '100%',
    background: theme.mode.backgroundColor.medium,
  },
  content: {
    padding: 0,
  },
}), { name: 'NotificationDrawer' })

const NotificationDrawer = (props) => {
  const { open, onClose } = props
  const classes = useStyles()
  const styles = useMemo(() => ({
    wrapper: classes.wrapper,
    children: classes.content,
  }), [classes])

  return (
    <DrawerWithOffset
      anchor='right'
      open={open}
      styles={styles}
      className={classes.drawerContainer}
      dataQsId='notificationDrawer-drawerWithOffset'
      onClose={onClose}>
      {open ? <Notifications /> : null}
    </DrawerWithOffset>
  )
}

export default NotificationDrawer
